import { NavLink } from "react-router-dom";
import FooterInstagramIcon from "../../../assets/images/footer/footer-instagramicon.png";

import FooterLogo from "../../../assets/images/footer/footer-logo.png";
import Icon from "../../Icon";

import * as S from "./styled";

const Footer = () => (
  <S.FooterComponent>
    <div className="inner">
      <S.FooterContentWrap>
        <S.FooterLogo className="header-logo">
          <Icon>
            <img src={FooterLogo} alt="logo" />
          </Icon>
        </S.FooterLogo>
        <S.FooterTextWrap>
          <div>
            <h6>국제실용댄스지도자협회</h6>
            {/* <p>
              서울특별시 동작구 사당로 14길 10, 지하1층
              <br />
              Tel 010-2351-8784, 010-7620-8784
            </p> */}
          </div>
          <span>© 2024 IPDIA. All Rights Reserved.</span>
        </S.FooterTextWrap>
      </S.FooterContentWrap>
    </div>
  </S.FooterComponent>
);

export default Footer;
